import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  addBanner,
  updateBanner,
  getBannerById,
  removeBannerImage,
} from 'actions/EntityActions';
import { showError, showSnackbar } from 'actions/CommonActions';
import LOOKUP from 'constants/lookup';
import SelectInput from 'screens/components/basic/SelectInput';
import { bannerEditCrumb, bannerAddCrumb } from 'utils/breadcrumbInfo';
import WithRouter from 'custom/withRouter';
import TextInput from 'screens/components/basic/TextInput';
import Button from 'screens/components/basic/Button';
import ToggleInput from 'screens/components/basic/ToggleInput';
import CardSimple from 'screens/components/basic/CardSimple';
import Grid from 'screens/components/basic/Grid';
import { initializeBannerForm } from 'actions/FormActions';
import ImageUploader from './components/ImageUploader';
import './styles/bannerManagement.scss';

const bannerSaveComponentName = 'banner';
const convertBlobToBase64 = (blobUrl) => {
  return new Promise((resolve) => {
    fetch(blobUrl)
      .then((res) => res.blob())
      .then((blob) => {
        const reader = new FileReader();
        reader.readAsDataURL(blob);
        reader.onloadend = () => {
          resolve(reader.result);
        };
      });
  });
};

class BannerManagement extends Component {
  constructor(props) {
    super(props);
    this.state = {
      status: 'ADD',
      images: [],
      bannerTypeOptions: [{ value: 1, text: 'Main Banner' }],
      selectedBranch: 1,
    };
    this.handleRemoveImage = this.handleRemoveImage.bind(this);
    this.handleAddImages = this.handleAddImages.bind(this);
    this.handleSaveBanner = this.handleSaveBanner.bind(this);
    this.cancel = this.cancel.bind(this);
  }

  componentDidMount() {
    const bannerId = this.props.params?.id;
    if (bannerId) {
      this.setState({ status: 'EDIT' });
      this.props.getBannerById(bannerId);
    } else {
      this.props.init(bannerSaveComponentName);
    }
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.bannerData &&
      this.props.bannerData !== prevProps.bannerData
    ) {
      this.initializeFormWithBannerData(this.props.bannerData);
    }
    // Handle save success/failure
    if (this.props.saveSuccess !== prevProps.saveSuccess) {
      if (this.props.saveSuccess) {
        this.saveSuccessBanner();
      } else if (this.props.saveSuccess === false) {
        this.saveFailure();
      }
    }

    if (this.props.getSuccess !== prevProps.getSuccess) {
      if (this.props.getSuccess) {
        this.getSuccess();
      } else if (this.props.getSuccess === false) {
        this.getFailure();
      }
    }

    if (
      prevProps[`${bannerSaveComponentName}IsGlobal`] !==
        this.props[`${bannerSaveComponentName}IsGlobal`] &&
      this.props[`${bannerSaveComponentName}IsGlobal`]
    ) {
      this.setState({ selectedBranch: 1 });
    }
  }

  initializeFormWithBannerData(banner) {
    this.props.init(bannerSaveComponentName, {
      [`${bannerSaveComponentName}BannerName`]: banner.bannerName,
      [`${bannerSaveComponentName}TargetUrl`]: banner.targetUrl,
      [`${bannerSaveComponentName}BannerAlt`]: banner.bannerAlt,
      [`${bannerSaveComponentName}BannerType`]:
        parseInt(banner.bannerType) || 0,
      [`${bannerSaveComponentName}BannerDescription`]: banner.bannerDescription,
      [`${bannerSaveComponentName}IsGlobal`]: banner.isGlobal,
      [`${bannerSaveComponentName}IsActive`]: banner.isActive,
      [`${bannerSaveComponentName}DisplayOrder`]: banner.displayOrder,
      [`${bannerSaveComponentName}BranchId`]: banner.branchId,
    });
    if (banner.images) {
      const bannerImages = banner.images || [];

      this.setState({
        images: Array.isArray(bannerImages)
          ? bannerImages.map((img) => ({
              ID: img.id || 0,
              URLImage: img.urlImage,
              DisplayMode: img.displayMode || 0,
              ImageID: img.imageID,
            }))
          : JSON.parse(bannerImages),
      });
    }
    this.setState({
      selectedBranch: banner.branchId || this.props.branchId || 1,
    });
  }

  saveSuccessBanner() {
    this.props.showSnackbar('Banner saved successfully');
    this.props.navigate('/ecommerce/bannerList');
    this.props.resetBannerSaveSuccess();
  }

  saveFailure() {
    this.props.showError('Error saving banner');
  }

  getSuccess() {
    this.props.showSnackbar('Banner loaded successfully');
  }

  getFailure() {
    this.props.showSnackbar('Data loaded successfully');
  }

  async handleSaveBanner() {
    const { status, images } = this.state;
    if (!images || images.length === 0) {
      this.props.showError('Please upload at least one banner image');
      return;
    }
    const bannerId = status === 'EDIT' ? this.props.params.id : 0;

    const formValues = {
      bannerName: this.props[`${bannerSaveComponentName}BannerName`] || '',
      targetUrl: this.props[`${bannerSaveComponentName}TargetUrl`] || '',
      bannerAlt: this.props[`${bannerSaveComponentName}BannerAlt`] || '',
      bannerType:
        parseInt(this.props[`${bannerSaveComponentName}BannerType`]) || 1,
      bannerDescription:
        this.props[`${bannerSaveComponentName}BannerDescription`] || '',
      isGlobal: this.props[`${bannerSaveComponentName}IsGlobal`] || false,
      isActive: this.props[`${bannerSaveComponentName}IsActive`] !== false,
      displayOrder:
        parseInt(this.props[`${bannerSaveComponentName}DisplayOrder`]) || 0,
    };

    const model = {
      ...formValues,
      id: bannerId,
      branchId: formValues.isGlobal
        ? 1
        : this.state.selectedBranch || this.props.branchId,
      images: images.map((img) => ({
        id: img.ID || 0,
        urlImage: img.URLImage,
        displayMode: img.DisplayMode,
        imageID: img.ImageID,
      })),
    };

    if (status === 'EDIT') {
      this.props.updateBanner(model);
    } else {
      this.props.addBanner(model);
    }
  }

  handleRemoveImage(imageId) {
    const { images } = this.state;
    const bannerId = this.props.params?.id;

    if (bannerId) {
      this.props.removeBannerImage({
        ID: bannerId,
        ImageID: imageId,
      });
    }

    this.setState({
      images: images.filter((img) => img.ImageID !== imageId),
    });
  }

  async handleAddImages(files, newPreviews) {
    const { images } = this.state;

    const newImages = await Promise.all(
      newPreviews.map(async (img) => {
        let finalUrl = img.url;

        if (img.url.startsWith('blob:')) {
          finalUrl = await convertBlobToBase64(img.url);
        }

        return {
          ID: 0,
          ImageID: img.id,
          URLImage: finalUrl,
          DisplayMode: img.displayMode || 0,
        };
      })
    );

    const newDisplayModes = newImages.map((p) => p.DisplayMode);
    const hasDuplicates = newDisplayModes.some((mode) =>
      images.some((img) => img.DisplayMode === mode)
    );

    if (hasDuplicates) {
      this.props.showError('Each display mode can only be used once');
      return;
    }

    this.setState((prevState) => ({
      images: [...prevState.images, ...newImages],
    }));
  }

  cancel() {
    this.props.navigate('/ecommerce/bannerList');
  }

  getDisplayModeText(mode) {
    switch (mode) {
      case 0:
        return 'Desktop';
      case 1:
        return 'Tablet';
      case 2:
        return 'Mobile';
      default:
        return 'Desktop';
    }
  }
  handleBranchSelect(branchId) {
    this.setState({ selectedBranch: branchId });
  }
  handleBranchSelect(branchId) {
    this.setState({ selectedBranch: branchId });
  }
  render() {
    const { status, images, bannerTypeOptions } = this.state;
    const breadCrumbPage = status === 'EDIT' ? bannerEditCrumb : bannerAddCrumb;
    const existingImages = images.map((img) => ({
      id: img.ImageID,
      url: img.URLImage,
    }));
    return (
      <Grid headerContent={breadCrumbPage}>
        <CardSimple className="paddingForMobileDevices mt-2 pa-2">
          <div className="row">
            <div className="col-lg-4 col-md-4 col-sm-4 col-xs-12">
              <h4>Banner Management</h4>
            </div>
            <div className="col-lg-8 col-md-8 col-sm-8 col-xs-12 text-right mt-20px">
              <ImageUploader
                multiple={false}
                maxFiles={10}
                maxSizeMB={5}
                aspectRatio={{ width: 4, height: 1 }}
                acceptedFormats={['image/jpeg', 'image/png', 'image/webp']}
                existingImages={existingImages}
                onUpload={this.handleAddImages}
                onDelete={this.handleRemoveImage}
                existingDisplayModes={images.map((img) => img.DisplayMode)}
                label="Upload Banner Images"
              />
            </div>
            <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
              <TextInput
                name={`${bannerSaveComponentName}BannerName`}
                floatingLabelText="Banner Name"
                fullWidth={true}
                hintText="Enter banner name"
                required
              />
            </div>
            <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
              {!this.props[`${bannerSaveComponentName}IsGlobal`] && (
                <SelectInput
                  name={`${bannerSaveComponentName}BranchId`}
                  floatingLabelText="Select Branch"
                  options={this.props.brachOptions}
                  fullWidth={true}
                  value={this.state.selectedBranch}
                  onChange={(value) => this.handleBranchSelect(parseInt(value))}
                />
              )}
            </div>

            <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
              <TextInput
                name={`${bannerSaveComponentName}TargetUrl`}
                floatingLabelText="Target URL"
                fullWidth={true}
                hintText="Enter target URL"
                required
              />
            </div>
            <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
              <SelectInput
                name={`${bannerSaveComponentName}BannerType`}
                floatingLabelText="Banner Type"
                options={bannerTypeOptions}
                fullWidth={true}
                defaultValue={parseInt(this.props.banner?.bannerType) || 1}
              />
            </div>

            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
              <TextInput
                name={`${bannerSaveComponentName}BannerDescription`}
                floatingLabelText="Description"
                fullWidth={true}
                hintText="Enter banner description"
                multiLine={true}
                rows={2}
              />
            </div>
            <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
              <TextInput
                name={`${bannerSaveComponentName}BannerAlt`}
                floatingLabelText="Alt"
                fullWidth={true}
                hintText="Enter Alt text"
                required
              />
            </div>
            <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
              <ToggleInput
                name={`${bannerSaveComponentName}IsGlobal`}
                label="Apply to all branches"
              />
            </div>

            <div className="col-xs-12 col-sm-3 col-md-3 col-lg-3 col-xl-3">
              <TextInput
                name={`${bannerSaveComponentName}DisplayOrder`}
                floatingLabelText="Display Order"
                type="number"
                fullWidth={true}
              />
            </div>
            <div className="col-xs-12 col-sm-3 col-md-3 col-lg-3 col-xl-3 ml-2">
              <ToggleInput
                name={`${bannerSaveComponentName}IsActive`}
                label="Status"
              />
            </div>
          </div>

          <div className="row mt-3">
            {images.map((image, index) => (
              <div
                className="col-lg-3 col-md-4 col-sm-6 col-xs-12 mb-3"
                key={index}
              >
                <div className="banner-image-container">
                  <img
                    src={image.URLImage}
                    alt={`Banner ${index}`}
                    className="img-responsive"
                  />
                  <div className="image-display-mode">
                    {this.getDisplayModeText(image.DisplayMode)}
                  </div>
                  <Button
                    type="IconButton"
                    icon="delete"
                    className="image-remove-btn"
                    onTouchTap={() => this.handleRemoveImage(image.ImageID)}
                  />
                </div>
              </div>
            ))}
          </div>

          <div className="row">
            <div className="col-lg-12">
              <Button
                name="buttonSave"
                className="pull-right btnNewBrandPOS"
                label={LOOKUP.banner.controls.saveButton}
                primary={true}
                onTouchTap={this.handleSaveBanner}
              />

              <Button
                name="cancelButton"
                type="CancelButton"
                className="pull-right btn-space btnCleanSearch"
                label={LOOKUP.banner.controls.backButton}
                onTouchTap={this.cancel}
              />
            </div>
          </div>
        </CardSimple>
      </Grid>
    );
  }
}

function mapStateToProps(state) {
  const formValues = {};
  const formFields = [
    'BannerName',
    'TargetUrl',
    'BannerAlt',
    'BannerType',
    'BannerDescription',
    'IsGlobal',
    'IsActive',
    'DisplayOrder',
    'BranchId',
  ];

  formFields.forEach((field) => {
    formValues[`${bannerSaveComponentName}${field}`] =
      state.form[`${bannerSaveComponentName}${field}`];
  });
  let branches = state.common.userBranches || [];
  let brachOptions = [];
  branches.map((item) => {
    brachOptions.push({
      text: item.name,
      value: item.id.toString(),
    });
  });
  return {
    ...formValues,
    bannerData: state.entity.bannerData,
    saveSuccess: state.entity.bannersSaveSuccess,
    getSuccess: state.entity.bannerGetSuccess,
    branchId: state.common.branchId,
    branches: state.common.userBranches || [],
    brachOptions: brachOptions,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    addBanner: (payload) => dispatch(addBanner(payload)),
    updateBanner: (payload) => dispatch(updateBanner(payload)),
    removeBannerImage: (payload) => dispatch(removeBannerImage(payload)),
    init: (name, payload) => dispatch(initializeBannerForm(name, payload)),
    showSnackbar: (message) => dispatch(showSnackbar(message)),
    getBannerById: (payload) => dispatch(getBannerById(payload)),
    showError: (message) => dispatch(showError(message)),
    formError: (name, error) => dispatch({ type: 'FORM_ERROR', name, error }),
    resetBannerSaveSuccess: () => dispatch({ type: 'RESET_BANNER_SAVE_SUCCESS' }),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(WithRouter(BannerManagement));
